import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/global.css';

import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import AppSpinner from './atoms/AppSpinner';
import DashboardPage from './pages/DashboardPage';
import MenuPage from './pages/MenuPage';
import AddonGroupsPage from './pages/AddonGroupsPage';
import OrdersPage from './pages/OrdersPage';
import PdvPage from './pages/PdvPage';
import SettingsPage from './pages/SettingsPage';
import AuthPage from './pages/AuthPage';
import CompleteProfilePage from './pages/CompleteProfilePage';

function RequireAuth({ children }) {
  const { isAuthenticated, establishment, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <AppSpinner />
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/entrar" replace />;

  if (!establishment.whatsappNumber && location.pathname !== '/completar-cadastro') {
    return <Navigate to="/completar-cadastro" replace />;
  }

  return children;
}

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <BrowserRouter>
          <Routes>
            {/* As duas rotas caem no mesmo componente: entrar e cadastrar
                são faces do mesmo cartão, e o caminho só define qual delas
                aparece primeiro. */}
            <Route path="/entrar"   element={<AuthPage />} />
            <Route path="/cadastro" element={<AuthPage />} />
            <Route path="/completar-cadastro" element={<RequireAuth><CompleteProfilePage /></RequireAuth>} />
            {/* Pedidos é a tela de entrada — o Dashboard, que antes ocupava a
                raiz, está em desenvolvimento e fora da navegação. */}
            <Route path="/"               element={<Navigate to="/pedidos" replace />} />
            <Route path="/cardapio"       element={<RequireAuth><MenuPage /></RequireAuth>} />
            <Route path="/cardapio/adicionais" element={<RequireAuth><AddonGroupsPage /></RequireAuth>} />
            <Route path="/pdv"            element={<RequireAuth><PdvPage /></RequireAuth>} />
            <Route path="/pedidos"        element={<RequireAuth><OrdersPage /></RequireAuth>} />
            <Route path="/configuracoes"  element={<RequireAuth><SettingsPage /></RequireAuth>} />
            {/* Sem link em nenhum menu: só chega aqui quem digitar a URL,
                para acompanhar o desenvolvimento da tela. */}
            <Route path="/dashboard"      element={<RequireAuth><DashboardPage /></RequireAuth>} />
            <Route path="*"               element={<Navigate to="/pedidos" replace />} />
          </Routes>
        </BrowserRouter>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
